import { Container, Section, Grid } from '../layout';
import { Card, Icon } from '../ui';
import { firmData } from '../../data/firmData';

export const LeadershipSection = () => {
  const leadership = firmData.leadership[0]; // Primary leadership profile

  const teamHighlights = [
    {
      icon: 'briefcase',
      title: 'Diverse Expertise',
      description: 'Our team brings together specialists from various legal domains, ensuring comprehensive coverage of all practice areas.'
    },
    {
      icon: 'star',
      title: 'Proven Track Record',
      description: 'Collective experience of handling complex legal matters with successful outcomes across different industries.'
    },
    {
      icon: 'users',
      title: 'Collaborative Approach',
      description: 'We work as a unified team, combining individual expertise to deliver the best possible results for our clients.'
    },
    {
      icon: 'lightbulb',
      title: 'Continuous Learning',
      description: 'Commitment to staying updated with evolving legal landscapes and emerging industry trends.'
    }
  ];

  return (
    <Section id="leadership" padding="xl" className="bg-background-white">
      <Container>
        <div className="text-center mb-16">
          <h2 className="heading-lg text-primary-navy mb-6">
            Leadership & Team
          </h2>
          <p className="body-lg text-text-medium max-w-3xl mx-auto">
            Our leadership combines decades of legal expertise with a vision for innovative legal solutions, 
            supported by a dedicated team of experienced legal professionals.
          </p>
        </div>

        {/* Leadership Profile */}
        <div className="mb-16">
          <Card className="p-8 lg:p-12 bg-background-light">
            <div className="grid lg:grid-cols-3 gap-8 lg:gap-12 items-start">
              {/* Leadership Photo */}
              <div className="lg:col-span-1">
                <div className="aspect-square rounded-lg overflow-hidden mb-6 lg:mb-0">
                  <img
                    src="/images/leadership/nandakumar.jpg"
                    alt={`${leadership.name} - ${leadership.title}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              {/* Profile Content */}
              <div className="lg:col-span-2">
                <div className="mb-6">
                  <h3 className="heading-lg text-primary-navy mb-2">
                    {leadership.name}
                  </h3>
                  <p className="body-lg text-accent-gold font-medium mb-4">
                    {leadership.title}
                  </p>
                </div>

                <div className="prose prose-lg max-w-none mb-8">
                  <p className="body-base text-text-medium leading-relaxed">
                    {leadership.biography}
                  </p>
                </div>

                {/* Credentials */}
                {/* <div>
                  <h4 className="font-semibold text-primary-navy mb-4 text-lg">
                    Professional Credentials & Experience
                  </h4>
                  <div className="space-y-3">
                    {leadership.credentials.map((credential, index) => (
                      <div key={index} className="flex items-start">
                        <Icon 
                          name="check" 
                          size="sm" 
                          className="text-accent-gold mr-3 mt-1 flex-shrink-0" 
                        />
                        <span className="body-base text-text-medium">
                          {credential}
                        </span>
                      </div>
                    ))}
                  </div>
                </div> */}
              </div>
            </div>
          </Card>
        </div>

        {/* Team Highlights */}
        <div className="mb-16">
          <h3 className="heading-md text-primary-navy mb-8 text-center">
            Our Team Excellence
          </h3>
          <Grid cols={{ default: 1, md: 2, lg: 4 }} gap="lg">
            {teamHighlights.map((highlight, index) => (
              <Card key={index} variant="hover" className="p-6 text-center h-full">
                <div className="w-12 h-12 bg-accent-gold/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon name={highlight.icon as any} size="lg" className="text-accent-gold" />
                </div>
                <h4 className="font-semibold text-primary-navy mb-3">
                  {highlight.title}
                </h4>
                <p className="body-sm text-text-medium">
                  {highlight.description}
                </p>
              </Card>
            ))}
          </Grid>
        </div>

        {/* Team Statistics */}
        <div className="bg-primary-navy rounded-lg p-8 text-center">
          <h3 className="heading-md text-background-white mb-8">
            Our Team by Numbers
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div>
              <div className="text-3xl font-bold text-accent-gold mb-2">
                {firmData.statistics.legalAssociates}+
              </div>
              <div className="text-background-white/80 text-sm">
                Legal Associates
              </div>
            </div>
            <div>
              <div className="text-3xl font-bold text-accent-gold mb-2">
                25+
              </div>
              <div className="text-background-white/80 text-sm">
                Years Combined Experience
              </div>
            </div>
            <div>
              <div className="text-3xl font-bold text-accent-gold mb-2">
                6
              </div>
              <div className="text-background-white/80 text-sm">
                Practice Areas
              </div>
            </div>
            <div>
              <div className="text-3xl font-bold text-accent-gold mb-2">
                100%
              </div>
              <div className="text-background-white/80 text-sm">
                Client Satisfaction
              </div>
            </div>
          </div>
        </div>

        {/* Professional Associations */}
        {/* <div className="mt-16 text-center">
          <h3 className="heading-md text-primary-navy mb-8">
            Professional Associations & Memberships
          </h3>
          <div className="bg-background-light rounded-lg p-8">
            <Grid cols={{ default: 1, md: 2, lg: 3 }} gap="lg">
              <div className="flex items-center justify-center p-4">
                <div className="text-center">
                  <Icon name="scale" size="xl" className="text-accent-gold mx-auto mb-2" />
                  <p className="body-sm text-text-medium">Bar Council of Tamil Nadu</p>
                </div>
              </div>
              <div className="flex items-center justify-center p-4">
                <div className="text-center">
                  <Icon name="briefcase" size="xl" className="text-accent-gold mx-auto mb-2" />
                  <p className="body-sm text-text-medium">Indian Council of Arbitration</p>
                </div>
              </div>
              <div className="flex items-center justify-center p-4">
                <div className="text-center">
                  <Icon name="globe" size="xl" className="text-accent-gold mx-auto mb-2" />
                  <p className="body-sm text-text-medium">International Bar Association</p>
                </div>
              </div>
            </Grid>
          </div>
        </div> */}

        {/* Call to Action */}
        <div className="mt-12 text-center">
          <p className="body-lg text-text-medium mb-6">
            Meet our experienced team and discover how our leadership can guide your legal journey.
          </p>
          <button 
            onClick={() => {
              const contactSection = document.getElementById('contact');
              if (contactSection) {
                contactSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="btn-base btn-primary"
          >
            Schedule a Consultation
          </button>
        </div>
      </Container>
    </Section>
  );
};